import { Country } from 'App/i18n/enums';
import { useStoreInfo } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';

const MAX_TRANSFER_AMOUNT_AR = 500_000_000;
const MIN_TRANSFER_AMOUNT_MX = 10;

export function useTransferValidation() {
  const { t } = useTranslationWithPrefix('partialTransfer.transferAmountForm');
  const { storeInfo } = useStoreInfo();

  const validate = (amount: number, maxAvailable: number): string | null => {
    if (
      storeInfo?.country === Country.MEXICO &&
      amount < MIN_TRANSFER_AMOUNT_MX
    ) {
      return t('minAmountError');
    }

    if (
      storeInfo?.country === Country.ARGENTINA &&
      amount > MAX_TRANSFER_AMOUNT_AR
    ) {
      return t('maxAmountError');
    }

    if (amount > maxAvailable) {
      return t('helpText');
    }

    return null;
  };

  return { validate, t };
}
